/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_DistributableFeatureManageDto } from '../models/Wealthlane_Dtos_DistributableFeatureManageDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DistributableFeatureService {

    /**
     * @param requestBody
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse OK
     * @throws ApiError
     */
    public static postApiIdentityApiDistributableFeaturesManage(
        requestBody?: Wealthlane_Dtos_DistributableFeatureManageDto,
    ): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericCreatedApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/distributable-features/manage',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param distributableCompanyId
     * @returns Wealthlane_Dtos_DistributableFeatureManageDto OK
     * @throws ApiError
     */
    public static getApiIdentityApiDistributableFeatures(
        distributableCompanyId: string,
    ): CancelablePromise<Array<Wealthlane_Dtos_DistributableFeatureManageDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/identity/api/distributable-features/{distributableCompanyId}',
            path: {
                'distributableCompanyId': distributableCompanyId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
